<template>
    <el-row :gutter="20" class="main_block">
        <div class="mianContent">
            <div class="tagView">
                <span class="goback" @click="goback"><i class="el-icon-back"></i> 返回</span>
            </div>
            <div>
                <iframe :src="frameSrc" :style="{height: height}" frameborder="0" scrolling="no"></iframe>
            </div>
        </div>
    </el-row>
</template>

<script>
export default {
    data() {
        return {
            frameSrc:process.env.VUE_APP_RULES+'/refundPolicy.html',
            height:'auto',
        };
    },

    components: {},

    computed: {},

    created() {},

    mounted() {
        window.addEventListener("message",(event)=>{
            console.log(event)
            if (event && event.data && typeof event.data === 'string') {
                let obj = JSON.parse(event.data)
                if (obj.type === 'setHeight') {
                    this.height = obj.data + 'px'
                }
            }
        }, false)
    },
    methods:{
        goback(){
            zhuge.track('用户中心_立即购买_计费规则返回',()=>{
                this.$router.push({path:'/userAccount/buy'})
            });
        }
    }
};
</script>
<style lang="less" scoped>
.tagView{
    position: relative;
    .goback{
        position: absolute;
        right:0;
        top:-50px;
        display: block;
        color:#999999;
        cursor: pointer;
        &:hover{
            color:#3F7DF7;
        }
    }
}
iframe{
    width: 100%;
}

</style>
